import { LessonsSummarySection } from '@/components/home/LessonsSummarySection';
import { MercadoPagoCard } from '@/components/home/MercadoPagoCard';
import { TournamentsSummarySection } from '@/components/home/TournamentsSummarySection';
import { useAutoStartTour } from '@/features/guided-help';
import { useAuth } from '@/hooks/useAuth';
import type React from 'react';
import { Navigate } from 'react-router-dom';

const Inicio: React.FC = () => {
  const { hasOwnerRole, hasManagerRole, hasInstructorRole, isFutureOwner } = useAuth();
  const isManager = hasOwnerRole || hasManagerRole;

  useAutoStartTour('panel.inicio');

  if (isFutureOwner) {
    return <Navigate to="/clubs" replace />;
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6 p-4">
      <h1 className="text-[20px] font-bold text-gc-ink">Inicio</h1>
      {isManager && (
        <div data-guide-id="panel.inicio.tournaments">
          <TournamentsSummarySection />
        </div>
      )}
      {hasInstructorRole && <LessonsSummarySection />}
      <div data-guide-id="panel.inicio.mercadopago">
        <MercadoPagoCard />
      </div>
    </div>
  );
};

export default Inicio;
